<template>
  <div class="ChatListPage">
    <!-- 对话列表 -->
    <van-pull-refresh
      v-model="listOnRefreshing"
      @refresh="listOnRefresh"
      v-show="bottomNavType == 1"
      class="pull-refresh"
    >
      <van-list
        class="chatListBox"
        v-model="listLoading"
        :finished="finished"
        finished-text="没有更多了"
        @load="listOnLoad"
        :immediate-check="false"
      >
        <div
          class="topHint"
          v-if="
            totalTokenCount - currentTokenCount <= 0 && totalTokenCount != 0
          "
        >
          <div class="leftText">今日剩余会话字数</div>
          <div
            class="rightNum"
            :class="{
              limit: totalTokenCount - currentTokenCount <= 0,
            }"
          >
            {{ totalTokenCount - currentTokenCount }}/{{ totalTokenCount }}
          </div>
        </div>
        <div class="topHint" v-else>
          <div class="leftText">今日剩余会话条数</div>
          <div
            class="rightNum"
            :class="{
              limit: (isVip ? vipTotalCount : totalCount) - currentCount <= 0,
            }"
          >
            {{ (isVip ? vipTotalCount : totalCount) - currentCount }}/{{
              isVip ? vipTotalCount : totalCount
            }}
          </div>
        </div>
        <!-- 引导  -->
        <div class="guideBox" v-if="guideList.length > 0">
          <div class="guideItem" v-for="(value, key) in guideList" :key="key">
            <div class="guideTitle">
              <img class="guideIcon" :src="value.icon" alt="" />
              <span>{{ value.name }}</span>
            </div>
            <div class="guideContent">
              <div
                v-for="(value2, key2) in value.guideList"
                :key="key2"
                class="guideContentItem"
                @click="clickGuideAgent(value2.agentCode)"
              >
                {{ value2.text }}
              </div>
            </div>
          </div>
        </div>

        <div class="chatList">
          <!-- 剩下的是正常的历史记录 -->
          <van-swipe-cell
            v-for="(value, key) in historyList"
            :key="'' + value.ai_app_code + key"
          >
            <div
              class="chatItem"
              :class="{
                topUpFlag: value.topUpFlag || value.type == 'default',
              }"
              @click="goToDetailPage(value)"
            >
              <img class="agent_icon" :src="value.icon" alt="" />
              <div class="rightBox">
                <div class="line1">
                  <div class="name">{{ value.name }}</div>
                  <div class="vipTag" v-if="value.vipOnly == 1">会员专属</div>
                  <!-- 如果当前用户是会员 -->
                  <div class="rightText" v-if="calculateChatLimit(value)">
                    {{ calculateChatLimit(value) }}
                  </div>
                </div>
                <div class="line2">{{ value.introduction }}</div>
              </div>
            </div>
            <template #right>
              <div class="right_swipe_cell_box">
                <div
                  class="btn blue"
                  @click="clickSetTop(value)"
                  v-show="value.type != 'default'"
                >
                  <img
                    v-show="!value.topUpFlag"
                    src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/set_top_icon.png"
                    alt=""
                    class="icon"
                  />
                  <img
                    v-show="value.topUpFlag"
                    src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/cancel_set_top_icon.png"
                    alt=""
                    class="icon"
                  />
                  <div class="text">
                    {{ value.topUpFlag ? "取消置顶" : "置顶" }}
                  </div>
                </div>
                <div
                  class="btn orange"
                  v-show="value.type == 'normal'"
                  @click="clickEditBtn(value)"
                >
                  <img
                    src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/edit_white_icon.png"
                    alt=""
                    class="icon"
                  />
                  <div class="text">编辑</div>
                </div>
                <div
                  class="btn red"
                  v-show="value.type != 'default'"
                  @click="clickDeleteBtn(value)"
                >
                  <img
                    src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/delete_white_icon.png"
                    alt=""
                    class="icon"
                  />
                  <div class="text">删除</div>
                </div>
              </div>
            </template>
          </van-swipe-cell>
        </div>
      </van-list>
    </van-pull-refresh>
    <div class="container" v-show="bottomNavType == 2">
      <!-- 发现列表 -->
      <div class="findList">
        <div
          class="findItem"
          v-for="(value, key) in findList"
          :key="key"
          @click="findItemClick(value)"
        >
          <img class="agent_icon" :src="value.icon" alt="" />
          <div class="rightBox">
            <div class="line1">
              <div class="name">{{ value.name }}</div>
              <div class="vipTag" v-if="value.vipOnly == 1">会员专属</div>
            </div>
            <div class="line2">{{ value.desction }}</div>
          </div>
          <img
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/add_icon.png"
            alt=""
            class="rightBtn"
            v-if="value.status == 0"
            @click.stop="addFindAgent(value)"
          />
          <img
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/added_icon.png"
            alt=""
            class="rightBtn"
            v-if="value.status == 1"
            @click.stop="deleteFindAgent(value)"
          />
        </div>
      </div>
    </div>
    <div class="mineContainer" v-show="bottomNavType == 3">
      <div class="mineList">
        <div class="mineItem" @click="navigateToAgreement">
          <div class="itemText">服务协议</div>
          <img
            class="arrowImg"
            src="https://appflzt.oss-cn-shanghai.aliyuncs.com/static-h5/AI_H5/right_arrow_icon_gray.png"
          />
        </div>
        <div class="divider" v-if="showLogout"></div>
        <div
          class="mineItem"
          v-if="showLogout"
          @click="showLogoutDialog = true"
        >
          <div class="itemTextRed">退出帐号</div>
          <img
            class="arrowImg"
            src="https://appflzt.oss-cn-shanghai.aliyuncs.com/static-h5/AI_H5/right_arrow_icon_gray.png"
          />
        </div>
      </div>
    </div>
    <!-- 底部遮罩 -->
    <div class="bottomShadeBox">
      <!-- 底部悬浮 -->
      <div class="bottomNav">
        <div class="bottomNavContent">
          <div class="bottomNavBox">
            <div
              class="slideBox"
              :class="{ right: bottomNavType == 2, right2: bottomNavType == 3 }"
            ></div>
            <div
              @click="changeBottomNavType(1)"
              class="item"
              :class="{ item_active: bottomNavType == 1 }"
            >
              对话
            </div>
            <div
              @click="changeBottomNavType(2)"
              class="item"
              :class="{ item_active: bottomNavType == 2 }"
            >
              发现
            </div>
            <div
              @click="changeBottomNavType(3)"
              class="item"
              :class="{ item_active: bottomNavType == 3 }"
            >
              我的
            </div>
          </div>
        </div>
      </div>

      <!-- 新对话 悬浮 -->
      <div class="floatBtn" v-show="bottomNavType == 1 && newChatInfo">
        <img
          v-show="
            totalCount - currentCount > 0 &&
            totalTokenCount - currentTokenCount > 0
          "
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/new_chat_icon.png"
          alt=""
          class="new_chat_icon"
          @click="clickNewChat"
        />
        <img
          v-show="
            totalCount - currentCount <= 0 ||
            totalTokenCount - currentTokenCount <= 0
          "
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/new_chat_icon_disabled.png"
          alt=""
          class="new_chat_icon"
          @click="showLimitDialog = true"
        />
      </div>
    </div>

    <!-- 确认删除 -->
    <commonDialog2
      :show="showDeleteDialog"
      titleContent="确定删除对话？"
      textContent="删除后，聊天记录将不可恢复"
      leftBtnText="取消"
      leftBtnColor="#007AFF"
      leftBtnBold
      rightBtnText="删除"
      rightBtnColor="#DC2626"
      @clickLeft="showDeleteDialog = false"
      @clickRight="confirmDelete"
    ></commonDialog2>
    <!-- 会话额度已用完 -->
    <commonDialog2
      :show="showLimitDialog"
      titleContent="今日会话额度已用完，请明日再试。"
      leftBtnText="我知道了"
      leftBtnColor="#007AFF"
      leftBtnBold
      @clickLeft="showLimitDialog = false"
    ></commonDialog2>
    <!-- 修改名称 -->
    <commonDialog2
      :show="showEditDialog"
      titleContent="对话名称"
      leftBtnText="取消"
      leftBtnColor="#007AFF"
      leftBtnBold
      rightBtnText="确定"
      rightBtnColor="#007AFF"
      @clickLeft="showEditDialog = false"
      @clickRight="confirmSubmit"
    >
      <template>
        <div class="inputBox">
          <input maxlength="20" class="input" type="text" v-model="inputText" />
        </div>
      </template>
    </commonDialog2>
    <!--  使用协议的弹窗  -->
    <commonDialog3 v-model="showAgreementDialog"> </commonDialog3>
    <!-- 确认退出登录 -->
    <commonDialog2
      :show="showLogoutDialog"
      titleContent="确定退出账号？"
      textContent=""
      leftBtnText="取消"
      leftBtnColor="#007AFF"
      leftBtnBold
      rightBtnText="退出"
      rightBtnColor="#DC2626"
      @clickLeft="showLogoutDialog = false"
      @clickRight="confirmLogout"
    ></commonDialog2>

    <!-- 会员专属提示 dialog -->
    <commonDialog2
      :show="showVipOnlyDialog"
      titleContent="该智能体为会员专属智能体"
      textContent="开通会员后，可与专属智能体对话。"
      leftBtnText="取消"
      leftBtnColor="#007AFF"
      leftBtnBold
      rightBtnText="去开通"
      rightBtnColor="#007AFF"
      @clickLeft="showVipOnlyDialog = false"
      @clickRight="clickOpenVipBtn"
    ></commonDialog2>
    <transition name="fade">
      <loading v-show="loading"></loading>
    </transition>
  </div>
</template>

<script>
// 引入API
import * as Http from "@/api/HttpService.js";
import CommonDialog3 from "@/components/commonDialog3/commonDialog3.vue";
import { specialCodeHead, imgContentHead } from "@/config/config";
import { businessCodeMatch } from "@/utils/businessCodeMatch";
export default {
  components: { CommonDialog3 },
  computed: {
    // 判断当前是否还有 渠道会话额度
    isHasChatLimit: function () {
      if (this.isVip) {
        return (
          this.vipTotalCount - this.currentCount > 0 &&
          this.totalTokenCount - this.currentTokenCount > 0
        );
      } else {
        return (
          this.totalCount - this.currentCount > 0 &&
          this.totalTokenCount - this.currentTokenCount > 0
        );
      }
    },
  },
  data: function () {
    return {
      // 1=>对话 2=>发现
      bottomNavType: 1,
      showDeleteDialog: false,
      showClearDialog: false,
      showLimitDialog: false,
      showEditDialog: false,
      pageNum: 0,
      pageSize: 10,
      listLoading: false,
      listOnRefreshing: false,
      finished: false,
      historyList: [],
      findList: [],
      currentCount: 0,
      totalCount: 0,
      vipTotalCount: 0,
      currentTokenCount: 0,
      totalTokenCount: 0,

      inputText: "",
      // 待编辑的会话
      editValue: null,
      // 待删除的会话
      deleteValue: null,
      // 全局loading
      loading: false,
      reDrawStr: null,
      newChatInfo: null,
      defaultChatInfo: null,
      //使用协议的弹框
      showAgreementDialog: false,
      //是否展示退出登录：第三方登录展示，其他渠道不展示
      showLogout: false,
      //退出登录的弹出框
      showLogoutDialog: false,
      guideList: [],
      isVip: false,
      // 会员专属dialog提示
      showVipOnlyDialog: false,
    };
  },
  methods: {
    // 计算 对话列表  额度该显示什么
    calculateChatLimit: function (value) {
      // 如果没拿到总额度  那么暂时什么都不显示
      if (!this.totalTokenCount) {
        return false;
      }
      // 总额度已用完
      if (!this.isHasChatLimit) {
        return "总额度已用完";
      }
      // 用户是会员    并且智能体的会员额度 没有额度限制
      if (this.isVip && value.vipChatLimit === null) {
        return false;
      }
      // 用户不是会员   并且智能体的普通额度 没有额度限制
      if (!this.isVip && value.chatLimit === null) {
        return false;
      }
      if (this.isVip && value.vipOnly == 1) {
        return `会员额度 ${value.vipChatLimit - value.usedCount}/${
          value.vipChatLimit
        }`;
      }
      if (this.isVip && value.vipOnly == 0) {
        return `会员额度 ${value.vipChatLimit - value.usedCount}/${
          value.vipChatLimit
        }`;
      }
      if (!this.isVip && value.vipOnly == 1) {
        return `会员已过期`;
      }
      if (!this.isVip && value.vipOnly == 0) {
        return `今日剩余 ${value.chatLimit - value.usedCount}/${
          value.chatLimit
        }`;
      }
    },
    // 获取会员信息
    getUserVipInfo: async function () {
      let params = {
        bizSession: localStorage.getItem("sessionId"),
      };
      await Http.getUserVipInfo(params).then(({ res }) => {
        console.log(res);
        if (res.code == "SUCCESS") {
          this.isVip = res.originalData.data.status == "1" ? true : false;
        }
      });
    },
    // 点击去开通会员按钮
    clickOpenVipBtn: function () {
      let url = process.env.VUE_APP_VIP_LIUZHOU_H5;
      url =
        url +
        `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
          "sessionId"
        )}&target=VipDetailPage`;
      window.location.href = url;
    },
    // 点击引导列表中的智能体
    clickGuideAgent: function (agentCode) {
      this.$router.push({
        name: "ChatDetailPage",
        query: {
          ai_app_code: agentCode,
          conversation_id: null,
          name: null,
          autoJumpToAgent: true,
        },
      });
    },
    // 获取新对话和默认对话
    getNewChat: async function () {
      let result = await Http.getNewChat({})
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            if (res.originalData.data) {
              // 拿到新对话数据
              if (res.originalData.data.normal) {
                this.newChatInfo = res.originalData.data.normal;
                this.$store.commit("newChatInfo", res.originalData.data.normal);
              }
              // 拿到默认对话数据
              if (res.originalData.data.default) {
                this.defaultChatInfo = res.originalData.data.default;
                this.$store.commit(
                  "defaultChatInfo",
                  res.originalData.data.default
                );
                let url = window.location.href;
                // 如果地址栏中已经包含了share_ai_app_code   那么直接返回就行
                if (url.indexOf("share_ai_app_code") != -1) {
                  return;
                }
                if (url.indexOf("?") != -1) {
                  url = url + "&";
                } else {
                  url = url + "?";
                }
                url =
                  url +
                  `share_ai_app_code=${
                    this.defaultChatInfo.ai_app_code
                  }&desction=${
                    this.defaultChatInfo.desction
                  }&shareImgUrl=${encodeURIComponent(
                    this.defaultChatInfo.shareImgUrl
                  )}`;
                window.history.replaceState(null, document.title, url);
              }
            }
            // 没配置新对话
            else {
            }
          }
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 切换底部状态
    changeBottomNavType: function (value) {
      if (this.bottomNavType == value) {
        return;
      }
      this.bottomNavType = value;
      this.$store.commit("bottomNavType", value);
      if (value == 1) {
        window.document.title = "对话";
        this.listOnRefresh();
      }
      if (value == 2) {
        window.document.title = "发现";
        this.getFindList();
      }
      if (value == 3) {
        window.document.title = "我的";
      }
    },
    // 点击 置顶or取消置顶
    clickSetTop: async function (value) {
      console.log(value);
      let params = {
        ai_app_code: value.ai_app_code,
      };
      if (
        this.newChatInfo &&
        value.ai_app_code == this.newChatInfo.ai_app_code
      ) {
        params.conversation_id = value.conversation_id;
      }
      // 如果当前是置顶状态
      if (value.topUpFlag) {
        // 取消置顶操作
        params.operate = "cancel";
      } else {
        // 置顶操作
        params.operate = "up";
      }
      let result = await Http.conversationSetTop(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            value.topUpFlag
              ? this.$toast("取消置顶成功")
              : this.$toast("置顶成功");
            this.listOnRefresh();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络异常");
        });
    },
    // 点击编辑按钮 弹出编辑弹窗
    clickEditBtn: function (value) {
      console.log(value);
      this.showEditDialog = true;
      this.inputText = value.name;
      this.editValue = value;
    },
    // 点击确认编辑
    confirmSubmit: async function () {
      if (this.inputText == "") {
        this.$toast("请输入内容");
        return;
      }
      let params = {
        ai_app_code: this.editValue.ai_app_code,
        conversation_id: this.editValue.conversation_id,
        name: this.inputText,
      };
      await Http.conversationRename(params)
        .then(({ res }) => {
          if (res.code == "SUCCESS") {
            this.$toast("编辑成功");
            this.showEditDialog = false;
            this.listOnRefresh();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络异常");
        });
    },
    // 点击删除按钮
    clickDeleteBtn: async function (value) {
      console.log(value);
      this.showDeleteDialog = true;
      this.deleteValue = value;
    },
    // 确认删除
    confirmDelete: async function () {
      // 如果有conversation_id    代表是从左侧列表触发了删除
      if (this.deleteValue.conversation_id) {
        let params = {
          conversation_id: this.deleteValue.conversation_id,
          ai_app_code: this.deleteValue.ai_app_code,
        };
        await Http.deleteMessage(params)
          .then(({ res }) => {
            console.log(res);
            if (res.code == "SUCCESS") {
              this.$toast("删除成功");
              this.showDeleteDialog = false;
              this.listOnRefresh();
              //迭代后 发现列表页也存在返回conversation_id
              this.getFindList();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      // 否则是右侧列表触发了删除
      else {
        let params = {
          ai_app_code: this.deleteValue.ai_app_code,
        };
        await Http.deleteAgent(params)
          .then(({ res }) => {
            console.log(res);
            if (res.code == "SUCCESS") {
              this.$toast("删除成功");
              this.showDeleteDialog = false;
              this.getFindList();
              this.listOnRefresh();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 点击确认清除
    confirmClear: function () {
      this.showClearDialog = false;
    },
    // 刷新历史会话
    listOnRefresh: async function () {
      this.listOnRefreshing = true;
      this.pageNum = 1;
      await this.getHistoryMessageList(true);
      this.getConversationCount();
      this.listOnRefreshing = false;
    },
    // 加载历史会话
    listOnLoad: function () {
      console.log("list触底");
      this.pageNum++;
      this.getHistoryMessageList();
    },
    // 获取历史会话列表   refresh  是否是刷新列表
    getHistoryMessageList: async function (refresh) {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.loading = true;
      await Http.getHistoryMessageList(params)
        .then(async ({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            if (refresh) {
              this.historyList = [];
            }
            let data = res.originalData.data.data;
            let specialCodeHeadLength = specialCodeHead.length;
            let imgContentHeadLength = imgContentHead.length;
            for (let i of data) {
              let currentHead_specialCodeHead = i.introduction.substring(
                0,
                specialCodeHeadLength
              );
              let currentHead_imgContentHead = i.introduction.substring(
                0,
                imgContentHeadLength
              );
              // 业务编码匹配
              if (currentHead_specialCodeHead == specialCodeHead) {
                let res2 = await businessCodeMatch(
                  i.introduction,
                  i.ai_app_code
                );
                if (res2.status == "success") {
                  i.introduction = res2.text;
                } else if (res2.status == "error") {
                  i.introduction = res2.text;
                }
              }
              //
              else if (currentHead_imgContentHead == imgContentHead) {
                i.introduction = "[图片]";
              }
            }
            this.historyList.push(...res.originalData.data.data);
            this.listLoading = false;
            // 还有下一页
            if (res.originalData.data.pageNum < res.originalData.data.pages) {
              this.finished = false;
            } else {
              this.finished = true;
            }
            this.sendChatListToNative();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络异常");
        });
      this.loading = false;
    },
    // 向native/小程序发送 对话列表数据
    sendChatListToNative: function () {
      let list = this.historyList;
      for (let i of list) {
        i.link = `#/WechatProgramLoginPage?ai_app_code=${i.ai_app_code}&channelCode=pinba&clientTypeFromBiz=wechat`;
      }
      console.log(list, "将要向小程序侧发送消息了");
      if (window.localStorage.getItem("channelCode_AI") == "pinba") {
        wx.miniProgram.postMessage({
          data: {
            type: "AI_CHAT_LIST",
            list: list,
          },
        });
      }
    },
    // 获取发现列表
    getFindList: async function () {
      let params = {};
      this.loading = true;
      await Http.getFindList(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            this.findList = res.originalData.data;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络异常");
        });
      this.loading = false;
    },
    // 添加发现内容
    addFindAgent: async function (value) {
      // 如果当前的智能体是会员专属，且当前智能体尚未添加，且用户当前不是会员
      if (value.vipOnly == 1 && value.status != 1 && this.isVip == false) {
        // 弹窗提示
        this.showVipOnlyDialog = true;
        return;
      }
      let params = {
        ai_app_code: value.ai_app_code,
      };
      this.loading = true;
      await Http.addAgent(params)
        .then(async ({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            this.$toast("添加成功");
            await this.getFindList();
            // 自动进入添加成功的页面
            this.goToDetailPage(value);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络异常");
        });

      this.loading = false;
    },
    // 删除发现内容
    deleteFindAgent: function (value) {
      console.log(value);
      this.showDeleteDialog = true;
      this.deleteValue = value;
    },
    // 获取今日会话次数
    getConversationCount: async function () {
      let params = {};
      await Http.getConversationCount(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            this.currentCount = res.originalData.data.currentCount;
            this.totalCount = res.originalData.data.totalCount;
            this.currentTokenCount = res.originalData.data.currentTokenCount;
            this.totalTokenCount = res.originalData.data.totalTokenCount;
            this.vipTotalCount = res.originalData.data.vipTotalCount;
            this.$store.commit(
              "currentCount",
              res.originalData.data.currentCount
            );
            this.$store.commit("totalCount", res.originalData.data.totalCount);
            this.$store.commit(
              "currentTokenCount",
              res.originalData.data.currentTokenCount
            );
            this.$store.commit(
              "totalTokenCount",
              res.originalData.data.totalTokenCount
            );
            this.$store.commit(
              "vipTotalCount",
              res.originalData.data.vipTotalCount
            );
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络异常");
        });
    },
    // 进入详情 （带conversation_id）
    goToDetailPage: function (value) {
      console.log(value);
      if (window.localStorage.getItem("channelCode_AI") == "pinba") {
        // wx.miniProgram.postMessage({
        //   data: {
        //     type: "AI",
        //     name: value.name,
        //     icon: value.icon,
        //     desction: value.desction,
        //     link: `#/WechatProgramLoginPage?ai_app_code=${value.ai_app_code}&channelCode=pinba&clientTypeFromBiz=wechat`,
        //   },
        // });
      }
      this.$router.push({
        name: "ChatDetailPage",
        query: {
          ai_app_code: value.ai_app_code,
          conversation_id: value.conversation_id,
          name: value.name,
        },
      });
    },
    // 点击新对话  进入详情  （不带conversation_id）
    clickNewChat: function () {
      // 如果是会员  看一下会员额度是否正常
      if (this.isVip) {
        if (
          this.vipTotalCount - this.currentCount <= 0 ||
          this.totalTokenCount - this.currentTokenCount <= 0
        ) {
          this.showLimitDialog = true;
          return;
        }
      } else {
        if (
          this.totalCount - this.currentCount <= 0 ||
          this.totalTokenCount - this.currentTokenCount <= 0
        ) {
          this.showLimitDialog = true;
          return;
        }
      }
      if (window.localStorage.getItem("channelCode_AI") == "pinba") {
        // wx.miniProgram.postMessage({
        //   data: {
        //     type: "AI",
        //     name: this.newChatInfo.name,
        //     icon: this.newChatInfo.icon,
        //     desction: this.newChatInfo.desction,
        //     link: `#/WechatProgramLoginPage?ai_app_code=${this.newChatInfo.ai_app_code}&channelCode=pinba&clientTypeFromBiz=wechat`,
        //   },
        // });
      }
      this.$router.push({
        name: "ChatDetailPage",
        query: {
          ai_app_code: this.newChatInfo.ai_app_code,
          name: this.newChatInfo.name,
        },
      });
    },
    //点击发现列表事件
    findItemClick: function (value) {
      //当已添加时，跳转会话详
      if (value.status == 1) {
        this.goToDetailPage(value);
      } else {
        //未添加时，点击添加
        this.addFindAgent(value);
      }
    },
    //跳转使用协议
    navigateToAgreement: function () {
      let channelCode = window.localStorage.getItem("channelCode_AI");
      console.log(channelCode);
      switch (channelCode) {
        case "dxlc":
          window.location.href = process.env.VUE_APP_AGREEMENT_H5_DXLC;
          return;
        case "cxnt":
          window.location.href = process.env.VUE_APP_AGREEMENT_H5_CXNT;
          return;
        case "pinba":
          window.location.href = process.env.VUE_APP_AGREEMENT_H5_PINBA;
          return;
      }
    },
    //退出登录
    confirmLogout: async function () {
      this.loading = true;
      await Http.logout({})
        .then(({ res }) => {
          console.log(res);
          if (res.originalData.code == "SUCCESS") {
            // 清楚本地的缓存
            // 登录成功
            window.localStorage.removeItem("sessionId_AI");
            window.localStorage.removeItem("appId_AI");
            window.localStorage.removeItem("userId_AI");
            window.localStorage.removeItem("phoneLogin_AI");
            window.localStorage.removeItem("clientType_AI");
            window.localStorage.removeItem("AI_Agreement");
            this.$toast(res.originalData.msg || "退出成功");
            // 退出成功到手机号登录页面
            setTimeout(() => {
              this.$router.replace({
                name: "SmsLoginPage",
              });
            }, 500);
          } else {
            this.$toast(res.originalData.msg || "网络异常");
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$toast("网络异常");
        });
      this.loading = false;
    },
    // 获取引导信息
    getGuides: async function () {
      let params = {};
      await Http.getGuides(params).then(({ res }) => {
        console.log(res);
        if (res.code == "SUCCESS") {
          this.guideList = res.originalData.data;
        }
      });
    },
  },
  mounted: async function () {
    this.historyList = [];
    this.findList = [];
    await this.getNewChat();
    await this.getGuides();
    await this.listOnLoad();
    await this.getUserVipInfo();
    // await this.getFindList();
    await this.getConversationCount();
    //获取载体是否来源亮啦，第三方需展示退出登录条目
    const channelApp = localStorage.getItem("channel_App") || "other";
    this.showLogout = channelApp == "other";
    //渠道用户首次访问时，访问页面弹窗展示使用协议
    const agreement = window.localStorage.getItem("AI_Agreement") || "0";
    if (agreement == "0") {
      this.showAgreementDialog = true;
      return;
    }
    // 修复白屏异常  非常离谱的操作
    window.scrollTo(0, 1);
    if (this.$route.params.autoJumpToAgent) {
      setTimeout(() => {
        this.$router.push({
          name: "ChatDetailPage",
          query: {
            ai_app_code: this.$route.params.autoJumpToAgent,
            conversation_id: null,
            name: null,
            autoJumpToAgent: true,
            userInputs: this.$route.params.userInputs || null,
          },
        });
      }, 500);
    } else if (this.$route.params.jumpFind) {
      // 切换到发现页面
      this.changeBottomNavType(2);
    } else {
      this.changeBottomNavType(this.$store.getters.bottomNavType);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./ChatListPage.scss";
</style>
